import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const names = ["LABEL.daily", "LABEL.weekly", "LABEL.monthly", "LABEL.yearly"];

type Props = {
  name: string;
  daysProps: ComponentProps<typeof Input>;
  onNameChange: (name: string) => void;
  nameError?: string;
  daysError?: string;
};

export function FrequencyFields({ name, daysProps, onNameChange, nameError, daysError }: Props) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <Label htmlFor="frequency-name">Nome da frequência de recebimento</Label>
        <select id="frequency-name" aria-invalid={Boolean(nameError)}
          aria-describedby={nameError ? "frequency-name-error" : undefined} value={name} onChange={(event) => onNameChange(event.target.value)}
          className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm">
          {names.map((value) => <option key={value} value={value}>{t(value)}</option>)}
          {!names.includes(name) && name && <option value={name}>{name}</option>}
        </select>
        {nameError && <p id="frequency-name-error" role="alert" className="text-sm text-app-danger">{nameError}</p>}
      </div>
      <div className="space-y-1">
        <Label htmlFor="frequency-days">Intervalo em dias</Label>
        <Input {...daysProps} id="frequency-days" type="number" min={1} max={2147483647} step={1}
          aria-invalid={Boolean(daysError)}
          aria-describedby={daysError ? "frequency-days-help frequency-days-error" : "frequency-days-help"}
          isInvalid={Boolean(daysError)} showError={false} />
        <p id="frequency-days-help" className="text-sm text-muted-foreground">
          Informe o total em dias: por exemplo, 7 para uma semana ou 30 para um mês.
          O nome não converte o intervalo. Frequências vinculadas a recebimentos não podem ser excluídas.
        </p>
        {daysError && <p id="frequency-days-error" role="alert" className="text-sm text-app-danger">{daysError}</p>}
      </div>
    </div>
  );
}
